import React, { useState, useEffect } from "react";
import "./Repotermanagement.css";
import Sidebar_admin from "../Sidebar_Admin/Sidebar_admin";
import axios from "../../../axiosInstance";

const Repotermanagement = () => {
  const [reporters, setReporters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedReporter, setSelectedReporter] = useState(null); // For modal
  const [statusFilter, setStatusFilter] = useState("Pending"); // Filter status
  const [searchQuery, setSearchQuery] = useState(""); // Mobile number search filter

  // Fetch reporters based on status and search query
  const fetchReporters = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(
        `/api/reporter/readall?status=${statusFilter}&searchQuery=${searchQuery}`
      );
      setReporters(response.data);
    } catch (err) {
      console.error("Error fetching reporters:", err);
      setError("Failed to load reporter data");
    } finally {
      setLoading(false);
    }
  };

  // Fetch reporters whenever status or search query changes
  useEffect(() => {
    fetchReporters();
  }, [statusFilter, searchQuery]);

  // Approve a reporter
  const handleApproval = async (reporterId) => {
    try {
      await axios.put(`/api/reporter/${reporterId}/status`, {
        status: "approved",
      });
      fetchReporters(); // Refresh data after status change
    } catch (err) {
      console.error("Error approving reporter:", err);
      setError("Failed to approve reporter");
    }
  };

  // Reject a reporter
  const handleRejection = async (reporterId) => {
    try {
      await axios.put(`/api/reporter/${reporterId}/status`, {
        status: "rejected",
      });
      fetchReporters(); // Refresh data after status change
    } catch (err) {
      console.error("Error rejecting reporter:", err);
      setError("Failed to reject reporter");
    }
  };

  // Open modal to view reporter details
  const openModal = async (reporterId) => {
    try {
      // Sending reporterId as a query parameter in the URL
      const response = await axios.get(`/api/reporter/admin`, {
        params: { reporterId } // This adds `reporterId` as a query parameter
      });
      setSelectedReporter(response.data.reporter);
      console.log("Profile Image:", selectedReporter.profileImage);

    } catch (err) {
      console.error("Error fetching reporter details:", err);
      setError("Failed to load reporter details");
    }
  };
  
  // Close modal
  const closeModal = () => {
    setSelectedReporter(null);
    fetchReporters(); // Refresh data after status change
  };

  return (
    <div>
      <Sidebar_admin />
      <div className="admin-panel">
        <h2 className="admin-panel__title">Reporter Management</h2>

        {/* Search Box */}
        <div className="admin-panel__search">
          <input
            type="text"
            className="admin-panel__search-input"
            placeholder="Search by Mobile Number..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Filter Buttons */}
        <div className="admin-panel__filters">
          <button
            className={`admin-panel__filter-button ${
              statusFilter === "Pending" ? "active" : ""
            }`}
            onClick={() => setStatusFilter("Pending")}
          >
            Pending
          </button>
          <button
            className={`admin-panel__filter-button ${
              statusFilter === "approved" ? "active" : ""
            }`}
            onClick={() => setStatusFilter("approved")}
          >
            Approved
          </button>
          <button
            className={`admin-panel__filter-button ${
              statusFilter === "rejected" ? "active" : ""
            }`}
            onClick={() => setStatusFilter("rejected")}
          >
            Rejected
          </button>
          <button
            className={`admin-panel__filter-button ${
              statusFilter === "All" ? "active" : ""
            }`}
            onClick={() => setStatusFilter("All")}
          >
            All
          </button>
        </div>

        {/* Data Table */}
        {loading ? (
          <p className="admin-panel__loading">Loading reporters...</p>
        ) : error ? (
          <p className="admin-panel__error">{error}</p>
        ) : (
          <table className="admin-panel__table">
            <thead>
              <tr>
                <th className="admin-panel__table-header">Reporter Name</th>
                <th className="admin-panel__table-header">Mobile Number</th>
                <th className="admin-panel__table-header">Email</th>
                <th className="admin-panel__table-header">Status</th>
                <th className="admin-panel__table-header">Actions</th>
              </tr>
            </thead>
            <tbody>
              
              {reporters.map((reporter) => (
                <tr key={reporter._id} className="admin-panel__table-row">
                  <td>
                    {reporter.firstName} {reporter.lastName}
                  </td>
                  <td>{reporter.mobileNumber}</td>
                  <td>{reporter.email}</td>
                  <td>{reporter.status}</td>
                  <td>
                    {reporter.status === "Pending" && (
                      <>
                        <button
                          className="admin-panel__button admin-panel__button--approve"
                          onClick={() => handleApproval(reporter._id)}
                        >
                          <i className="fas fa-check"></i> {/* Publish Icon */}
                        </button>
                        <button
                          className="admin-panel__button admin-panel__button--reject"
                          onClick={() => handleRejection(reporter._id)}
                        >
                          <i className="fas fa-times"></i> {/* Reject Icon */}{" "}
                        </button>
                      </>
                    )}
                    {reporter.status === "approved" && (
                      <>
                       
                        <button
                          className="admin-panel__button admin-panel__button--reject"
                          onClick={() => handleRejection(reporter._id)}
                        >
                          <i className="fas fa-times"></i> {/* Reject Icon */}{" "}
                        </button>
                      </>
                    )}{reporter.status === "rejected" && (
                      <>
                        <button
                          className="admin-panel__button admin-panel__button--approve"
                          onClick={() => handleApproval(reporter._id)}
                        >
                          <i className="fas fa-check"></i> {/* Publish Icon */}
                        </button>
                      
                      </>
                    )}
                    <button
                      className="admin-panel__button admin-panel__button--view"
                      onClick={() => openModal(reporter.reporterId)}
                    >
                      <i className="fas fa-eye"></i> {/* View Details Icon */}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Modal for Reporter Details */}
        {selectedReporter && (
  <div className="modal-content">
    <span className="modal-close" onClick={closeModal}>
      &times;
    </span>
    <h3>Reporter Details</h3>
    <div className="reporter-details">
      <p>
        <strong>First Name:</strong> {selectedReporter.firstName}
      </p>
      <p>
        <strong>Last Name:</strong> {selectedReporter.lastName}
      </p>
      <p>
        <strong>Email:</strong> {selectedReporter.email}
      </p>
      <p>
        <strong>Mobile Number:</strong> {selectedReporter.mobileNumber}
      </p>
      <p>
        <strong>District:</strong> {selectedReporter.district}
      </p>
      <p>
        <strong>State:</strong> {selectedReporter.state}
      </p>
      <p>
        <strong>Pincode:</strong> {selectedReporter.pincode}
      </p>
      <p>
        <strong>Status:</strong> {selectedReporter.status}
      </p>

        {/* Rendering profile image if exists */}
{/*         
  <img
    src={selectedReporter.profileImage}
    alt="Reporter Profile"
    className="reporter-profile-image"
    style={{ width: '150px', height: '150px', borderRadius: '50%' }}
  /> */}


      
    </div>
  </div>
)}


      </div>
    </div>
  );
};

export default Repotermanagement;
